import React, { useState, useEffect } from 'react';
import api from '../api';

function SecurityCenter() {
  const [score, setScore] = useState(0);
  const [twoFAEnabled, setTwoFA] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const [setup2FA, setSetup2FA] = useState(false);
  const [token2FA, setToken2FA] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchSecurityData();
  }, []);

  const fetchSecurityData = async () => {
    try {
      const profile = await api.get('/api/user/profile');
      setTwoFA(profile.data.twoFactorEnabled);
      const scoreRes = await api.get('/api/user/security-score');
      setScore(scoreRes.data.securityScore);
    } catch (err) {
      console.error(err);
    }
  };

  const enable2FA = async () => {
    try {
      const res = await api.post('/api/auth/2fa/setup');
      setQrCode(res.data.qrCode);
      setSetup2FA(true);
      setMessage('');
    } catch (err) {
      setMessage('Failed to generate QR code');
    }
  };

  const confirm2FA = async () => {
    try {
      await api.post('/api/auth/2fa/enable', { token: token2FA });
      setTwoFA(true);
      setSetup2FA(false);
      setToken2FA('');
      setMessage('2FA enabled successfully');
      fetchSecurityData();
    } catch (err) {
      setMessage('Invalid token, please try again');
    }
  };

  const disable2FA = async () => {
    try {
      await api.post('/api/auth/2fa/disable');
      setTwoFA(false);
      setMessage('2FA disabled');
      fetchSecurityData();
    } catch (err) {
      setMessage('Failed to disable 2FA');
    }
  };

  return (
    <div>
      <h2>Security Center</h2>
      {message && (
        <p style={{ color: message.includes('success') || message.includes('enabled') ? 'green' : 'red', marginBottom: '1rem' }}>
          {message}
        </p>
      )}

      <div className="card" style={{ maxWidth: '600px', marginBottom: '1.5rem' }}>
        <h3>Security Score</h3>
        <p style={{ fontSize: '2rem', fontWeight: 700, color: '#3b82f6' }}>{score}/100</p>
      </div>

      <div className="card" style={{ maxWidth: '600px' }}>
        <h3>Two-Factor Authentication (Google Authenticator)</h3>
        <p>
          <strong>Status:</strong>{' '}
          {twoFAEnabled ? (
            <span style={{ color: 'green' }}>✅ Enabled</span>
          ) : (
            <span style={{ color: 'red' }}>❌ Disabled</span>
          )}
        </p>

        {!twoFAEnabled && !setup2FA && (
          <button
            onClick={enable2FA}
            style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '0.5rem 1rem', borderRadius: '0.5rem', fontWeight: 500, cursor: 'pointer', marginTop: '1rem' }}
          >
            Set Up 2FA
          </button>
        )}

        {setup2FA && (
          <div style={{ marginTop: '1rem' }}>
            <p><strong>Scan this QR code with Google Authenticator:</strong></p>
            <img src={qrCode} alt="QR Code" style={{ margin: '1rem 0', border: '1px solid #e2e8f0', borderRadius: '0.5rem' }} />
            <div>
              <input
                type="text"
                placeholder="Enter 6-digit code"
                value={token2FA}
                onChange={e => setToken2FA(e.target.value)}
                style={{ padding: '0.5rem', borderRadius: '0.25rem', border: '1px solid #ccc', marginRight: '0.5rem' }}
              />
              <button
                onClick={confirm2FA}
                style={{ background: '#10b981', color: 'white', border: 'none', padding: '0.5rem 1rem', borderRadius: '0.25rem', fontWeight: 500, cursor: 'pointer' }}
              >
                Verify & Enable
              </button>
              <button
                onClick={() => setSetup2FA(false)}
                style={{ background: '#ef4444', color: 'white', border: 'none', padding: '0.5rem 1rem', borderRadius: '0.25rem', fontWeight: 500, cursor: 'pointer', marginLeft: '0.5rem' }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {twoFAEnabled && (
          <div style={{ marginTop: '1rem' }}>
            <button
              onClick={disable2FA}
              style={{ background: '#ef4444', color: 'white', border: 'none', padding: '0.5rem 1rem', borderRadius: '0.5rem', fontWeight: 500, cursor: 'pointer' }}
            >
              Disable 2FA
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SecurityCenter;